// extracted by mini-css-extract-plugin
export default {"wrapper":"Ci8ngjq5LK17XTOr0WLg","description":"_FR_hlyzSBZEC11cb0vR"};